import { render } from "./ProjectShareCode.vue?vue&type=template&id=0da3bb39&scoped=true"
import script from "./ProjectShareCode.vue?vue&type=script&lang=js"
export * from "./ProjectShareCode.vue?vue&type=script&lang=js"

import "./ProjectShareCode.vue?vue&type=style&index=0&id=0da3bb39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da3bb39"],['__file',"src/components/project/ProjectShareCode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0da3bb39"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0da3bb39', __exports__)) {
    api.reload('0da3bb39', __exports__)
  }
  
  module.hot.accept("./ProjectShareCode.vue?vue&type=template&id=0da3bb39&scoped=true", () => {
    api.rerender('0da3bb39', render)
  })

}


export default __exports__